<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <slot name="activator" dark :attrs="attrs" :on="on">
        <v-btn color="primary" dark v-bind="attrs" v-on="on">
          Open Dialog
        </v-btn>
      </slot>
    </template>
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Confirm action</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col col="12">
              <h3>
                Are you sure you want to create a subscription for the business
                <b>{{ business.name }}</b
                >?
                <!-- Please make sure you have collected a payment of
                <strong>{{ yearlyPriceCurrency }} {{ yearlyPrice }}</strong>
                from this business -->
              </h3>
            </v-col>
          </v-row>
          <v-row>
            <v-col col="12">
              <v-select
                v-model="selectedPeriod"
                :items="['1 month', '3 months', '1 year']"
                label="Period"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col col="12">
              <v-text-field
                label="Notes"
                color="primary"
                type="text"
                v-model="notes"
                prepend-icon="mdi-note"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col col="12" v-if="activeAccount.enabledDiscountCodes">
              <v-select
                v-model="selectedDiscountCode"
                :items="['', ...activeAccount.enabledDiscountCodes]"
                label="Discount Code"
              ></v-select>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog = false">
          Close
        </v-btn>
        <v-btn color="blue darken-1" text @click="makeBusinessPremium">
          Update to Premium
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import config from "../../config/config";

const getPeriod = (description) => {
  if (description == "1 month") return "P1M";
  if (description == "3 months") return "P3M";
  if (description == "6 months") return "P6M";
  if (description == "1 year") return "P1Y";
  return "P1Y"
};

export default {
  props: {
    business: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      enteredEmail: "",
      notifications: false,
      sound: true,
      widgets: false,
      rules: [
        (value) => !!value || "Required.",
        (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      ],
      selectedDiscountCode: null,
      selectedPeriod: "1 year",
      notes: "",
    };
  },
  computed: {
    ...mapGetters({
      activeAccount: "partner/active",
    }),
    yearlyPrice() {
      return 1990;
    },
    yearlyPriceCurrency() {
      return "SAR";
    },
    isWhitelabel() {
      return !!config.whitelabelMode;
    },
  },
  methods: {
    ...mapActions({
      fetchBusinesses: "business/fetchBusinesses",
      updateBusinessToPremium: "business/updateToPremium",
    }),
    async makeBusinessPremium() {
      this.dialog = false;
      try {
        this.$notifier.showMessage({
          content: "Updating..Please wait...",
        });
        await this.updateBusinessToPremium({
          accountId: this.activeAccount.id,
          business: this.business,
          discountCode: this.selectedDiscountCode,
          period: getPeriod(this.selectedPeriod),
          notes: this.notes,
        });
        this.$notifier.showMessage({
          content: "Updated to premium",
        });
        this.fetchBusinesses({
          activeAccount: this.activeAccount,
          bid: null,
          options: null,
        });
      } catch (error) {
        this.$notifier.showMessage({
          content:
            "Update to premium failed. Error: " + error.message || "unknown",
        });
      }
    },
  },
};
</script>
